import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import strings from '../../strings/strings.json'
import styles from './file_details_tabbar.module.css'
import VulnsRender from '../vulns_render'
import AppInfo from '../app_info'
import Antiviruses from '../antiviruses'
import { BugSecurityIcon } from './tabbar_icons/bug_security_icon'
import { BugVulnsIcon } from './tabbar_icons/bug_vulns_icon'
import { LibraryIcon } from './tabbar_icons/library_icon'
import { MoreInfoIcon } from './tabbar_icons/more_info_icon'
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  root: {
    fontFamily: 'Vazir',
    flexGrow: 1,
    width: '100%',
    marginBottom: "30px",
    marginTop: "30px",
    "&.css-heg063-MuiTabs-flexContainer": {
      display: 'none !important'
    },
    "&.MuiAppBar-colorDefault": {
      boxShadow: '0 5px 54px -5px rgba(130, 163, 166, 0.3)',
      backgroundColor: '#ffffff'
    },
    "&.MuiPaper-rounded": {
      borderTopLeftRadius: "20px",
      borderTopRightRadius: "20px",
    },
    "& .MuiTabs-root": {
      borderTopLeftRadius: "20px",
      borderTopRightRadius: "20px",
      boxShadow: "0 10px 80px 2px rgba(77, 72, 103, 0.15)"
    },
    "& .MuiTab-root": {
      outline: 0,
      minWidth: "190px",
    },
    "& .MuiTab-wrapper": {
      borderRight: "solid 1px rgba(151, 151, 151, 0.15)",
      display: "flex",
      flexDirection: "row",
      paddingRight: "20px",
      width: "195px"
    },
    "& .MuiTab-textColorPrimary": {
      color: "rgba(46, 39, 68, 0.5)"
    },
    "& .MuiTab-textColorPrimary.Mui-selected": {
      color: "#2e2744"
    },
    "& .MuiTabs-flexContainer": {
    },
  },
  tabs: {
    "&.MuiTabs-indicator": {
      right: 0,
      width: "160px",
      left: "810px !important",
      width: "190px !important",
    }
  }
})
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function FileDetailsTabbar(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (

    <div className={classes.root}>
      <Box sx={{ width: '100%' }} className={classes.tabbar}>
        <Box sx={{ width: '100%', bgcolor: 'background.paper' }} >
          <Tabs value={value} onChange={handleChange}
            variant="scrollable"
            TabIndicatorProps={{
              style: {
                backgroundColor: "#41b9a2",
                height: '5px',
                outline: 0
              }
            }}
          >
            <Tab {...a11yProps(0)} label={strings.general_moreInfo} icon={<div className={styles.tabbar_icon}><MoreInfoIcon isActive={value === 0 && true} /></div>} />
            <Tab {...a11yProps(1)} label={strings.fileDetail_vulnerabilities} icon={<div className={styles.tabbar_icon}><BugSecurityIcon isActive={value === 1 && true} /></div>} />
            <Tab  {...a11yProps(2)} label={strings.fileDetail_secRisk} icon={<div className={styles.tabbar_icon}><BugVulnsIcon isActive={value === 2 && true} /></div>} />
            <Tab {...a11yProps(3)} label={strings.general_libraryVulns} icon={<div className={styles.tabbar_icon}><LibraryIcon isActive={value === 3 && true} /></div>} />
            <Tab {...a11yProps(4)} label={strings.general_antiviruses} icon={<div className={styles.tabbar_icon}><BugVulnsIcon isActive={value === 4 && true} /></div>} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <AppInfo data={props.data !== undefined && props.data} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <VulnsRender data={props.data} type="high" isVulns={props.isVulns} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <VulnsRender data={props.data} type="low" isVulns={props.isVulns} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <VulnsRender data={props.data} type="lib" isVulns={props.isVulns} />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <Antiviruses hash={props.data.sha256} />
        </TabPanel>
      </Box>

    </div>
  );

}
{/* <div className={classes.root}>
      <Box sx={{ width: '100%' }} className={classes.tabbar}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" variant="scrollable" centered
            TabIndicatorProps={{
              style: {
                backgroundColor: "#41b9a2",
                height: '5px',
                outline: 0
              }
            }}
          >
            <Tab {...a11yProps(0)} label={strings.general_moreInfo} icon={<div className={styles.tabbar_icon}><MoreInfoIcon isActive={value === 0 && true} /></div>} />
            <Tab {...a11yProps(1)} label={strings.fileDetail_vulnerabilities} icon={<div className={styles.tabbar_icon}><BugSecurityIcon isActive={value === 1 && true} /></div>} />
            <Tab  {...a11yProps(2)} label={strings.fileDetail_secRisk} icon={<div className={styles.tabbar_icon}><BugVulnsIcon isActive={value === 2 && true} /></div>} />
            <Tab {...a11yProps(3)} label={strings.general_libraryVulns} icon={<div className={styles.tabbar_icon}><LibraryIcon isActive={value === 3 && true} /></div>} />
            <Tab {...a11yProps(4)} label={strings.general_antiviruses} icon={<div className={styles.tabbar_icon}><BugVulnsIcon isActive={value === 4 && true} /></div>} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <AppInfo data={props.data !== undefined && props.data} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <VulnsRender data={props.data} type="high" isVulns={props.isVulns} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <VulnsRender data={props.data} type="low" isVulns={props.isVulns} />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <VulnsRender data={props.data} type="lib" isVulns={props.isVulns} />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <Antiviruses hash={props.data.sha256} />
        </TabPanel>
      </Box>
    </div> */}